import { render, staticRenderFns } from "./IconArrowSorting.vue?vue&type=template&id=d9af5698"
import script from "./IconArrowSorting.vue?vue&type=script&lang=js"
export * from "./IconArrowSorting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports